import { render, staticRenderFns } from "./Os.vue?vue&type=template&id=34947b89"
import script from "./Os.vue?vue&type=script&lang=js"
export * from "./Os.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports